import Axios from './axios'

export default {
  getBusstops: (serviceAreaId, token) => {
    const axios = Axios.setup(serviceAreaId, token)
    const params = {
      serviceAreaIds: [serviceAreaId]
    }

    return new Promise((resolve) => {
      axios.get('busstops', { params })
        .then(payload => {
          const busstops = []
          payload.data.busstops.forEach((b) => {
            const d = b.busstopDescriptions[0] || {}
            const busstop = {
              id: b.id,
              name: b.name,
              imgUrl: d.imgUrl,
              description: d.description,
              location: {
                lat: parseFloat(b.lat),
                lng: parseFloat(b.lng)
              },
              enableBoarding: b.enableBoarding,
              enableDropOff: b.enableDropOff
            }
            busstops.push(busstop)
          })
          resolve(busstops)
        })
    })
  }
}
